import Vue from 'vue'
import Vuex from 'vuex'
import ky from 'ky'
import { createToken } from 'vue-stripe-elements-plus'

Vue.use(Vuex)

let existingUser = null

try {
  existingUser = JSON.parse(localStorage.getItem('user'))
} catch (e) {
  // no existing user
}

export default new Vuex.Store({
  state: {
    user: existingUser,
    token: localStorage.getItem('authToken'),
    projects: [],
    repos: []
  },
  mutations: {
    setUser (state, { user }) {
      state.user = user
      // saves it to the local storage
      localStorage.setItem('user', JSON.stringify(user))
    },
    setToken (state, { token }) {
      state.token = token
      // saves it to the local storage
      localStorage.setItem('authToken', token)
    },
    setProjects (state, { projects }) {
      state.projects = projects
      // Don't need local storage because you will get the list of projects every time
    },
    setRepos (state, { repos }) {
      state.repos = repos
      // Same as projects - don't need local storage because you will get the list of projects every time
    }
  },
  actions: {
    async login ({ commit }, { authCode }) {
      const response = await ky.post(process.env.VUE_APP_API + '/authenticated/github', {
        json: { authCode }
      }).json()

      commit('setUser', { user: response.user })
      commit('setToken', { token: response.auth.token })
    },
    async getProjects ({ commit, state }) {
      const projects = await ky.get(process.env.VUE_APP_API + '/api/v1/projects', { headers: {
        Authorization: `Bearer ${state.token}`
      } }).json()
      commit('setProjects', { projects })
    },
    async addProject ({ dispatch, state }, { project }) {
      const addProject = await ky.post(process.env.VUE_APP_API + '/api/v1/projects', {
        headers: {
          Authorization: `Bearer ${state.token}`
        },
        json: {
          'name': project.name,
          'type': project.type,
          'branch': project.branch,
          'repository': project.repository,
          'serve_command': project.serve_command,
          'rebuild_command': project.rebuild_command,
          'env': project.env,
          'password': project.password
        }
      }).json()
      console.log(addProject)
      dispatch('getProjects')
    },
    async createSubscription ({ state }) {
      try {
        const data = await createToken()
        console.log(data)
        const customer = await ky.post('https://sneaky-peek-staging.herokuapp.com/api/v1/stripe/create-customer', {
          headers: {
            Authorization: `Bearer ${state.token}`
          },
          json: data
        })
        console.log(customer)
      } catch (e) {
        console.log(e)
      }
    },
    async getRepos ({ commit, state }) {
      const repos = await ky.get(process.env.VUE_APP_API + '/api/v1/github/repositories', {
        headers: {
          Authorization: `Bearer ${state.token}`
        }
      }).json()
      commit('setRepos', { repos })
    }
  }
})

// *add projects array to the state
// *add mutation to set projects
// *actions to get the projects from the api

// in the component i created call the get projects action

// show the projects
